'use client'

import { cn } from '@/core/utils/common'

import { ItemArt } from '@/features/veluvit/components/ui/item-art'
import { fmt } from '@/features/veluvit/lib/format'

/* 재화 아이콘 — 젬 · 해금권(로얄 해금권은 2026-10-07 없앴다). 💎·🎟 이모지는 OS마다 모양이 달라 재화가 싸 보였고, 그 뒤 SVG 한 벌로 고쳤다가
   2026-10-01 생성한 게임 아이템 그림(ItemArt, public/images/veluvit/items)으로 앱 전체를 통일했다(사용자: "다이아 그림 뽑아둔 걸 왜 안 써").
   크기는 글자 크기를 따른다(1.3em — 그림 둘레 여백만큼 SVG 때보다 조금 크게) — 숫자 옆에 그대로 놓는다. size-* 를 주면 그 크기. */

/** 사이 젬 — 코랄 · 로즈 결정 그림 */
export function GemIcon({ className }: { className?: string }) {
  return (
    <ItemArt
      name="gem"
      className={cn(
        'align-middle',
        !className?.includes('size-') && 'size-[1.3em]',
        className
      )}
    />
  )
}

/** 젬 가격·수량 표기 — 아이콘 + 천 단위 숫자. 이전의 `{n}💎` 자리에 그대로 들어간다 */
export function GemAmount({
  value,
  className,
}: {
  value: number
  className?: string
}) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-0.5 align-middle leading-none tabular-nums',
        className
      )}
    >
      <GemIcon />
      <span className="sr-only">젬 </span>
      <span>{fmt(value)}</span>
    </span>
  )
}

/** 해금권 — 별 문양 입장권 그림 */
export function TicketIcon({ className }: { className?: string }) {
  return (
    <ItemArt
      name="ticket"
      className={cn(!className?.includes('size-') && 'size-[1.3em]', className)}
    />
  )
}
